import React, { createContext, useContext } from 'react';

const ProfilePictureContext = createContext();

export const useProfilePictureRefresh = () => {
  const context = useContext(ProfilePictureContext);
  if (!context) {
    throw new Error('useProfilePictureRefresh must be used within a ProfilePictureProvider');
  }
  return context;
};

export const ProfilePictureProvider = ({ children, refreshProfilePicture }) => {
  return (
    <ProfilePictureContext.Provider value={{ refreshProfilePicture }}>
      {children}
    </ProfilePictureContext.Provider>
  );
};
